export const categories = [
  {
    id: "interests",
    name: "兴趣圈子",
    icon: "ri-heart-3-line",
    color: "primary",
    description: "手作、摄影、露营、桌游……在这里找到同好，让每一种热爱都不孤单。",
    topicCount: 1284,
  },
  {
    id: "life",
    name: "生活日常",
    icon: "ri-sun-line",
    color: "accent",
    description: "记录三餐四季与生活里的细碎美好，分享属于你的日常片段。",
    topicCount: 2361,
  },
  {
    id: "professional",
    name: "专业讨论",
    icon: "ri-presentation-line",
    color: "secondary",
    description: "行业观察、技术思辨与深度论点，与专业伙伴一起拆解问题。",
    topicCount: 876,
  },
  {
    id: "experience",
    name: "经验分享",
    icon: "ri-lightbulb-line",
    color: "primary",
    description: "踩过的坑、走过的路，把真实经验留给后来的人。",
    topicCount: 1533,
  },
  {
    id: "tech",
    name: "数码科技",
    icon: "ri-smartphone-line",
    color: "accent",
    description: "新品评测、效率工具与 AI 玩法，聊聊正在改变生活的科技。",
    topicCount: 1042,
  },
  {
    id: "career",
    name: "职场成长",
    icon: "ri-briefcase-line",
    color: "secondary",
    description: "求职、晋升、副业与自我提升，一起把职场路走得更稳。",
    topicCount: 731,
  },
  {
    id: "food-travel",
    name: "美食旅行",
    icon: "ri-flight-takeoff-line",
    color: "primary",
    description: "城市味道与远方风景，用一份份攻略把想去的地方变成走过的路。",
    topicCount: 1198,
  },
  {
    id: "books-media",
    name: "读书影音",
    icon: "ri-book-open-line",
    color: "accent",
    description: "好书、好剧与好音乐，分享那些让你停顿下来的作品。",
    topicCount: 964,
  },
];